// Money and dates as the cabinet shows them.

import { state } from './state.ts';

/**
 * An amount in its currency, in the chosen language's notation; a bare "0.00" with no currency, as FormatCurrency
 * wrote it.
 * @param {number | null | undefined} amount
 * @param {string | null | undefined} currencyCode
 */
export function formatCurrency(amount: number | null | undefined, currencyCode: string | null | undefined) {
    const value = Number(amount) || 0;

    if (currencyCode && currencyCode.trim()) {
        try {
            return new Intl.NumberFormat(state.locale || undefined, { style: 'currency', currency: currencyCode.trim().toUpperCase() })
                .format(value);
        } catch {
            // Not an ISO code Intl knows: the plain number below.
        }
    }

    return value.toFixed(2);
}

/** "26 Oct 2026, 14:05", in the chosen language and this browser's time zone. */
export function formatDateTime(value: string | number | Date): string {
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) return '';

    const datePart = new Intl.DateTimeFormat(state.locale || undefined, { day: '2-digit', month: 'short', year: 'numeric' }).format(date);
    const timePart = new Intl.DateTimeFormat(state.locale || undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(date);

    return `${datePart}, ${timePart}`;
}
